import { render, staticRenderFns } from "./XiaCiDaiMaView.vue?vue&type=template&id=22584838&scoped=true"
import script from "./XiaCiDaiMaView.vue?vue&type=script&lang=js"
export * from "./XiaCiDaiMaView.vue?vue&type=script&lang=js"
import style0 from "./XiaCiDaiMaView.vue?vue&type=style&index=0&id=22584838&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22584838",
  null
  
)

export default component.exports